import React from 'react';
import { EditorialArticleShell, useEditorialNav } from './EditorialArticleShell';
import { getExamContent, getExamKeyFromHost, getExamSiteOrigin } from './examContext';
import { ExternalRedirect, PATHBUDDY_INSIGHTS_HOME } from './pathbuddyInsightRedirects';

export default function ExamInsightsPage() {
  const examKey = getExamKeyFromHost();
  const { navigate, goHome } = useEditorialNav(examKey);
  if (examKey === 'pathbuddy') return <ExternalRedirect href={PATHBUDDY_INSIGHTS_HOME} />;
  const content = getExamContent(examKey);
  const label = content.insights_label || `${content.exam} Insights`;
  const brandSuffix = examKey === 'pathbuddy' ? 'Pathbuddy' : 'IVORI Edu';

  return (
    <EditorialArticleShell
      examKey={examKey}
      title={`${label} — Guides & Analysis | ${brandSuffix}`}
      description={content.insights_sub}
      url={`${getExamSiteOrigin(examKey)}/insights`}
      keywords={
        examKey === 'pathbuddy'
          ? 'reasoning education, critical thinking, problem solving, grammar school, private school, selective admissions, Pathbuddy Insights'
          : undefined
      }
      backLabel="← Back to Main"
      onBack={goHome}
      eyebrow={label}
      heading={content.insights_title}
      meta={content.insights_sub}
      wide
    >
      <section className="lnat-ed-post-section">
        <div className="lnat-ed-container-wide">
          <div className="lnat-ed-post-grid">
            {(content.cards || []).map((card) => (
              <button
                key={card.slug}
                type="button"
                className="lnat-ed-post-card"
                onClick={() => navigate(`/insights/${card.slug}`)}
              >
                <span className="lnat-ed-card-tag">{card.tag}</span>
                <h3>{card.title}</h3>
                <p>{card.blurb}</p>
                <span className="lnat-ed-read-more">
                  Read <span>→</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>
    </EditorialArticleShell>
  );
}
